// pages/FormViewerPage/components/VariantOptions/index.tsx — VariantOptions composition
import React from 'react';
import { DropdownOption } from './DropdownOption';
import { RadioOption } from './RadioOption';
import { ModernOption } from './ModernOption';
import { getVariantDetails } from './variantDetails';
import { ms } from '../../../../locales/ms';
import type { VariantOptionsProps } from './types';

const VariantOptions: React.FC<VariantOptionsProps> = ({
    displayOptions,
    blockSpacingClass,
    selectedOptions,
    fieldErrors,
    onOptionChange,
    resolvedVariantCombinations,
    compositeFallback,
    variantStock,
    currentVariantStock,
    form,
}) => {
    if (displayOptions.length === 0) return null;

    return (
        <div className={`${blockSpacingClass} space-y-6`} data-variant-section>
            {displayOptions.map((option, index) => {
                const displayStyle = option.displayStyle || 'radio';
                const error = fieldErrors?.[`variant:${option.name}`];

                return (
                    <div key={option.id} className="space-y-3">
                        <div className="pb-2 border-b border-slate-200 dark:border-slate-700">
                            <h3 className="font-bold text-base text-slate-900 dark:text-slate-100">{option.name} <span className="text-red-500">*</span></h3>
                            <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{ms(form, m => m.variantHint, 'Pilih salah satu opsi di bawah')}</p>
                        </div>

                        {displayStyle === 'dropdown' && (
                            <DropdownOption option={option} selectedOptions={selectedOptions} onOptionChange={onOptionChange}
                                getVariantDetails={(name, val) => getVariantDetails(name, val, selectedOptions, resolvedVariantCombinations, compositeFallback)}
                                form={form} hasError={!!error} />
                        )}
                        {displayStyle === 'radio' && (
                            <RadioOption option={option} selectedOptions={selectedOptions} onOptionChange={onOptionChange}
                                getVariantDetails={(name, val) => getVariantDetails(name, val, selectedOptions, resolvedVariantCombinations, compositeFallback)}
                                variantStock={variantStock} form={form} />
                        )}
                        {displayStyle === 'modern' && (
                            <ModernOption option={option} selectedOptions={selectedOptions} onOptionChange={onOptionChange}
                                getVariantDetails={(name, val) => getVariantDetails(name, val, selectedOptions, resolvedVariantCombinations, compositeFallback)}
                                currentVariantStock={currentVariantStock} form={form} />
                        )}
                        {error && (
                            <p className="text-xs text-red-500 mt-1">⚠️ {error}</p>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default VariantOptions;
